export default "__VITE_ASSET__4ada08bb__"